export enum GoogleDriveActions {
  Upload = 'UPLOAD',
  Download = 'DOWNLOAD',
  Preview = 'PREVIEW'
}
